import { Reducer } from "redux";
import { Country } from "../../model/Country";
import * as countryActions from "./countryActions";

export interface CountryState {
  countries: Country[];
}

const initialState: CountryState = {
  countries: [],
};

type SupportedActions = countryActions.ListCountriesSuccessAction;

export const countryReducer: Reducer<CountryState, SupportedActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case countryActions.LIST_COUNTRIES_SUCCESS: {
      return {
        ...state,
        countries: action.countries || [],
      };
    }
    default: {
      return state;
    }
  }
};
